import React from 'react';
import './SettingsLayout.css';

const SettingsLayout = ({ nav, children }) => {
  return (
    <div className="settings-layout">
      <aside className="settings-nav">{nav}</aside>
      <main className="settings-content">{children}</main>
    </div>
  );
};

export default SettingsLayout;
